import { AxiosResponse } from 'axios'
import { TipoPendencia } from 'utils/types'

import { RequestCDU, RequestREAD } from '../Instances'

const RegisterPendingServices = () => {
  const path = 'TipoPendencia'
  const create = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Create`, requestObj)

  const del = async (id: number): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/Delete?id=${id}`)

  const getAll = async (params?: TipoPendencia): Promise<AxiosResponse<TipoPendencia[]>> =>
    await RequestREAD.get(path, {
      params: params
    })

  const get = async (id: number): Promise<AxiosResponse<TipoPendencia>> =>
    await RequestREAD.get(`${path}/${id}`)

  const patch = async (requestObj: TipoPendencia): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/Update`, requestObj)

  return { create, del, get, getAll, patch }
}

export { RegisterPendingServices }
